module.exports = __webpack_public_path__ + "img/exam_jan_2025_9fhqmjjh.fbb941ad.jpg";